/**
 * Стадии внимания Оператора к Тревожному инциденту. В каждый момент стадия одна,
 * и инцидент к ней приложен — раздельные флаги «идёт разговор», «оператор ушёл»
 * и «есть инцидент» умели складываться в состояния, которых не бывает.
 *
 * Порядок обычного разбора: RINGING → CONVERSATION → RESOLUTION → инцидента нет.
 * AWAY — ветка для инцидента, оставшегося без Оператора (см. presenceReRing).
 */
export const PANIC_STAGE = {
  RINGING: 'ringing',
  CONVERSATION: 'conversation',
  RESOLUTION: 'resolution',
  AWAY: 'away',
};

export default PANIC_STAGE;
